import React from 'react';
import { useTranslation } from 'react-i18next';
import TouchableOpacity from './TouchableOpacity';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import Text from './Text';
import { Row, Col } from 'reactstrap';
import getThemeLookup from '../selectors/getThemeLookup';
import type { IconType } from 'react-icons';
import combineStyles from '../utils/combineStyles';
import { SALE_TYPE_ICONS } from '../constants/saleTypes';
import { adjustSaleType } from '../thunks/adjustSaleType';
import { CONTAINER_PROPERTIES, TEXT_PROPERTIES } from '../utils/theme';
import { useLocation } from 'react-router-dom';
import { ORDER_TYPE_MODAL_ID } from '../modals/OrderTypeModal';

const SaleTypeListItem = ({
  saleType,
  locationId,
}: {
  saleType: SALE_TYPE;
  locationId?: string | null;
}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const p = useAppSelector(getThemeLookup);

  const renderIcon = (Icon: IconType) => {
    return Icon ? (
      <Icon size="35" style={combineStyles(p('saleTypeIcons', ['fontSize', 'color']))} />
    ) : null;
  };

  const modalParams = useAppSelector(state => state.modalParams);
  const currentModalId = useAppSelector(state => state.currentModalId);

  const inNestedOrderTypeModal = modalParams?.saleType && currentModalId === ORDER_TYPE_MODAL_ID;

  const browserLocation = useLocation<Location>();
  const isChild = browserLocation?.state?.saleType || inNestedOrderTypeModal;

  const saleTypeStringPrefix = isChild ? 'saleTypeChildren' : 'saleType';

  return (
    <TouchableOpacity
      onClick={() => {
        dispatch(adjustSaleType({ saleType: saleType, locationId, isChild }));
      }}
    >
      <Row
        className="p-3"
        style={combineStyles(
          { borderRadius: 5 },
          p('cardBorder', CONTAINER_PROPERTIES),
          p('saleTypeListItem', CONTAINER_PROPERTIES),
        )}
      >
        <Col xs="2" className="my-auto">
          <div>{renderIcon(SALE_TYPE_ICONS[saleType])}</div>
        </Col>
        <Col>
          <div>
            <Text
              variant="h1"
              value={t(`${saleTypeStringPrefix}.${saleType}.name`)}
              themeKey="pickSaleType"
              block
              style={p('orderingListItemText', TEXT_PROPERTIES)}
            />
            <Text
              value={t(`${saleTypeStringPrefix}.${saleType}.subtitle`)}
              themeKey="pickSaleTypeDescription"
              style={p('orderingListItemSubText', TEXT_PROPERTIES)}
            />
          </div>
        </Col>
      </Row>
    </TouchableOpacity>
  );
};

export default SaleTypeListItem;
